import { Query } from "react-apollo";
import gql from "graphql-tag";
import { Theme } from "../../../types/types";

type QueryVariables = {
  slug: string
}

export type QueryResult = {
  theme: Theme
}

export class ThemeShowQuery extends Query<QueryResult, QueryVariables> { }

export const query = () => {
  return gql`
    query Theme($slug:String!) {
      theme: themeBySlug(slug:$slug) {
        name
        bodyTitle
        bodyContent
        gitesCount
        bedAndBreakfastsCount
        giteOverviewPath
        bnbOverviewPath
        identifier
        listTitle
        slugsForBooleanSearch
        linkListItems {
          title
          url
        }
        bodyImage {
          url(crop:"original")
          exists
        }
        headerImage{
          url(crop:"header")
        }
        rentalAdverts(first:3) {
          nodes {
            id
            objectName
            path
            city {
              name
            }
            bedrooms
            bathrooms
            isStudio
            priceForOverview
            maxPersons
            overviewImage {
              url(crop: "index_thumb")
            }
            lastMinuteOffers(onlySoon: true) {
              nodes {
                id
              }
            }
            displayGuestbookEntries(onlyRateable:true) {
              nodes {
                rating
              }
            }
          }
        }
      }
    }
  `
}


export const variables = (slug: string) : QueryVariables => {
  return {
    slug: slug
  }
}
